module.exports = __webpack_public_path__ + "static/media/people.0903277e.png";